import React, { useState } from 'react';
var imageName = require('../static/stickers.png');

var howTo = require('../static/photo_2.jpg');
var results = require('../static/photo_1.jpg');

function HomePage() {
  const [isFaqExpanded, setIsFaqExpanded] = useState(false);
  const [isHowToExpanded, setIsHowToExpanded] = useState(false);

  return (
    <div className="rootWrapper">
      <div className="infoCardWrapper">
        <div className="infoCard">
          <div className="bannerImage">
            <img src={imageName} className="backgroundImage" alt="stickers" />
          </div>

          <div className="mainHeader">Furry Sticker Trade</div>
          <div className="mainSubHeader">Sticker Swap by Mail</div>
          <div
            className="mainSubHeader"
            style={{ marginTop: '10px', color: '#10b2f3' }}
          >
            ⚠️ Sticker Trade is Closed For the year, thanks for all the trading!
            ⚠️ - May 2026
          </div>
        </div>

        <div className="infoCard text">
          <div className="header">How It Works</div>
          <div className="emojiBulletList">
            <div className="emojiBullet">📬 Mail in your stickers</div>
            <div className="emojiBullet">
              ✉️ Include a stamped return envelope
            </div>
            <div className="emojiBullet">
              🎨 We swap in stickers from other artists
            </div>
            <div className="emojiBullet">💌 You get new stickers back</div>
          </div>
        </div>

        <div className="infoCard">
          <div className="header">About This Project</div>
          <div className="text">
            &emsp;A community sticker swap, done through the mail. Send stickers
            in, get a random mix back, and discover art from furry creators
            around the world.
          </div>
        </div>

        <div
          className="infoCard pointer"
          title={isHowToExpanded ? 'Collapse' : 'Expand to see more'}
          onClick={() => setIsHowToExpanded((s) => !s)}
        >
          <div className="header">How to trade:</div>

          <div className={isHowToExpanded ? '' : 'preview'}>
            <div className="qandaWrapper">
              <div className="">
                <div className="subheader">Step 1: Prepare Your Trade</div>
                <div className="text">
                  <div style={{ marginBottom: '10px' }}>
                    - You will need: 2 envelopes, stickers to trade and 2 stamps
                  </div>
                  <div style={{ marginBottom: '10px' }}>
                    - Place the stickers you want to trade inside one of the
                    envelopes
                  </div>
                  <div style={{ marginBottom: '10px' }}>
                    - Create a{' '}
                    <a href="https://en.wikipedia.org/wiki/Self-addressed_stamped_envelope">
                      self-addressed stamped envelope
                    </a>{' '}
                    addressed to yourself
                  </div>
                  <div>
                    - Fill out the outer envelope to mail to the Sticker
                    Exchange
                  </div>
                </div>

                {isHowToExpanded && (
                  <>
                    <div
                      className="qandaWrapper"
                      style={{ paddingTop: '20px' }}
                    >
                      <div className="qanda centerText">
                        <div className="subheader">Mail To:</div>
                        <div
                          className="addressText text"
                          style={{ textDecoration: 'line-through' }}
                        >
                          Sticker Exchange
                          <br />
                          PO BOX 530016
                          <br />
                          821 Herndon Ave
                          <br />
                          Orlando, FL 32803
                          <br />
                          United States
                        </div>
                      </div>
                    </div>

                    <div className="qandaWrapper">
                      <div className="qanda">
                        <div className="subheader">Step 2: Pack & Mail</div>
                        <div className="text">
                          <div style={{ marginBottom: '10px' }}>
                            - Make sure both envelopes are stamped and have your
                            address filled out correctly
                          </div>
                          <div style={{ marginBottom: '10px' }}>
                            - Fold the return envelope in half and put it inside
                            the sending envelope
                          </div>
                          <div style={{ marginBottom: '10px' }}>
                            - Put the stickers inside the parent envelope and
                            seal it up
                          </div>
                          <div>- Put your envelope in the mail</div>
                        </div>
                      </div>
                    </div>

                    <div style={{ textAlign: 'center', marginTop: '20px' }}>
                      <img src={howTo} className="headerImage" alt="stickers" />
                      <div
                        className="text"
                        style={{ marginTop: '10px', marginBottom: '20px' }}
                      >
                        <i>Example envelope</i>
                      </div>
                    </div>

                    <div className="qandaWrapper">
                      <div className="qanda">
                        <div className="subheader">Step 3: Wait & Receive</div>
                        <div className="text">
                          <div style={{ marginBottom: '10px' }}>
                            - Submission photos are posted bi-weekly on the{' '}
                            <a href="https://discord.gg/9J89xxVuwh">Discord</a>{' '}
                            and{' '}
                            <a href="https://t.me/+04EvQPRCJANmZmVj">
                              Telegram
                            </a>{' '}
                            channels
                          </div>
                          <div style={{ marginBottom: '10px' }}>
                            - Typical return time for traders in the USA is
                            around 1 to 2 months
                          </div>
                          <div>
                            - International return time for traders is 2 to 4
                            months
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="qandaWrapper">
                      <div className="qanda">
                        <div className="subheader">
                          Double Check Before Sending:
                        </div>
                        <div className="text">
                          <div>
                            📌 The inner envelope is addressed with you as the
                            recipient
                          </div>
                          <div style={{ marginBottom: '10px' }}>
                            📌 Your address is written legibly and correct
                          </div>
                          <div style={{ marginBottom: '10px' }}>
                            📌 Both envelopes are stamped
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="qandaWrapper">
                      <div className="qanda">
                        <div
                          className="subheader centerText"
                          style={{ paddingTop: 20 }}
                        >
                          🌏 International Traders 🌍
                        </div>
                        <div className="text">
                          If you live outside the USA, do{' '}
                          <strong style={{ fontWeight: 700 }}>not</strong>{' '}
                          include a stamp on your self-addressed envelope, as
                          the Post Office won't accept foreign stamps.
                          <br />
                          <br />
                          Instead, I'll add a free worldwide stamp to your
                          return envelope.
                        </div>
                      </div>
                    </div>

                    <div style={{ textAlign: 'center', marginTop: '20px' }}>
                      <img
                        src={results}
                        className="headerImage"
                        alt="stickers"
                      />
                      <div className="text" style={{ marginTop: '10px' }}>
                        <i>Example of return sticker packs from 2024</i>
                      </div>
                    </div>
                  </>
                )}
              </div>
            </div>
          </div>
        </div>

        <div
          className="infoCard pointer"
          onClick={() => setIsFaqExpanded((s) => !s)}
          title={isHowToExpanded ? 'Collapse' : 'Expand to see more'}
        >
          <div className="header">Frequently Asked Questions</div>

          <div className={`${isFaqExpanded ? '' : 'preview'}`}>
            <div className="subheader">
              <strong>Q. When will you get your stickers?</strong>
            </div>
            <div className="text">
              &emsp;On average for US based traders it's around a month or two.
              International traders typically take longer than 2 months.
            </div>

            {isFaqExpanded && (
              <>
                <div className="qandaWrapper">
                  <div className="qanda">
                    <div className="subheader">
                      <strong>Q. Why does it take so long?</strong>
                    </div>
                    <div className="text">
                      &emsp;This project is powered by the cheapest and slowest
                      class of mail and relies on volunteer time to sort and
                      swap the stickers manually. This combined with the current
                      political climate around the post office (especially
                      international!) can lead to long trade times.
                    </div>
                  </div>
                </div>
                <div className="qandaWrapper">
                  <div className="qanda">
                    <div className="subheader">
                      <strong>Q. What will you get?</strong>
                    </div>
                    <div className="text">
                      &emsp;A. An envelope mailed to you containing a random
                      assortment of furry stickers.
                    </div>
                  </div>
                </div>
                <div className="qandaWrapper">
                  <div className="qanda">
                    <div className="subheader">
                      <strong>Q. Why are you doing this?</strong>
                    </div>
                    <div className="text">
                      &emsp;The furry fandom has a strong culture of sticker
                      trading and it's become common at cons and meets. This
                      project was inspired by the Graffiti sticker trade run by
                      <a href="https://www.youtube.com/@S1VE"> S1VE </a>with the
                      idea of replicating that same community feeling over the
                      mail
                    </div>
                  </div>
                </div>
                <div className="qandaWrapper">
                  <div className="qanda">
                    <div className="subheader">
                      <strong>
                        Q. What happens when you don't get a return?
                      </strong>
                    </div>
                    <div className="text">
                      There is a REAL risk of mail getting lost. I'd estimate
                      around 5% of trades get lost somewhere in the void of the
                      post office. If your trade does get lost, please reach out
                      to me (WafflesFur@gmail.com) or (@WafflesTheRaccoon on
                      Telegram) and I'll do my best to make it right.
                    </div>
                  </div>
                </div>
                <div className="qandaWrapper">
                  <div className="qanda">
                    <div className="subheader">
                      <strong>Q. Can all the stickers be the same?</strong>
                    </div>
                    <div className="text">
                      &emsp;Yes! This is the most common submission. All the
                      duplicate stickers will get spread out among all the other
                      traders.
                    </div>
                  </div>
                </div>
                <div className="qandaWrapper">
                  <div className="qanda">
                    <div className="subheader">
                      <strong>Q. How many stickers should you submit?</strong>
                    </div>
                    <div className="text">
                      &emsp;The most common submission is around 20 stickers. In
                      the past people have sent anywhere between 5 - 100 , I try
                      my best to return an equivalent amount back.
                    </div>
                  </div>
                </div>
                <div className="qandaWrapper">
                  <div className="qanda">
                    <div className="subheader">
                      <strong>Q. What is a "Self Assigned Envelope"?</strong>
                    </div>
                    <div className="text">
                      &emsp;This is a second envelope included with your
                      stickers that will be used to mail your stickers back to
                      you. It should have your address as the recipient and the
                      Sticker Exchange as the sender. Please stamp your
                      envelope, if you're in the US all you need is a single
                      "Forever" stamp.
                    </div>
                  </div>
                </div>
                <div className="qandaWrapper">
                  <div className="qanda">
                    <div className="subheader">
                      <strong>Q. What stickers should you send?</strong>
                    </div>
                    <div className="text">
                      &emsp;A. Any furry themed stickers you like! Handmade,
                      commissioned, drawn or printed stickers are welcome.
                    </div>
                  </div>
                </div>
                <div className="qandaWrapper">
                  <div className="qanda">
                    <div className="subheader">
                      <strong>Q. What stickers are not allowed?</strong>
                    </div>
                    <div className="text">
                      &emsp;A. Do not send stickers that are unrelated to
                      animals or art, adult/NSFW themed or hateful in nature
                    </div>
                  </div>
                </div>
                <div className="qandaWrapper">
                  <div className="qanda">
                    <div className="subheader">
                      <strong>Q. What were the results from last year?</strong>
                    </div>
                    <div className="text">
                      &emsp;A. 2024: 54 participates and around 1000 stickers
                      swapped <br />
                      <br />
                      &emsp;A. 2025: 304 participates and around 10,000 stickers
                      swapped
                    </div>
                  </div>
                </div>
                <div className="qandaWrapper">
                  <div className="qanda">
                    <div className="subheader">
                      <strong>Q. What if you live in Russia?</strong>
                    </div>
                    <div className="text">
                      &emsp;A. I've gotten a few submissions from Russia, but
                      due to current mail restrictions I am unable to send
                      trades back. I dream for peace and that one day these
                      barriers will be lifted
                    </div>
                  </div>
                </div>
              </>
            )}
          </div>
        </div>

        <div className="infoCard">
          <div className="header">Join Our Community</div>
          <div className="text">
            <div style={{ marginBottom: '15px' }}>
              Connect with us on Discord and Telegram for updates and
              discussions.
            </div>
            <div className="linkLane">
              <a href="https://discord.gg/9J89xxVuwh">Discord</a> |{' '}
              <a href="https://t.me/+04EvQPRCJANmZmVj">Telegram Channel</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default HomePage;
